export enum EventType {
  CREATED = 'CREATED',
  LOGINED = 'LOGINED',
  LOGOUTED = 'LOGOUTED',
  FILE_SELECTED = 'FILE_SELECTED',
  FILE_DRAGSTART = 'FILE_DRAGSTART',
  FILE_DRAGEND = 'FILE_DRAGEND',
  OPEN_PR = 'OPEN_PR',
  SET_PLAYER_POSITION = 'SET_PLAYER_POSITION',
  KAFKA = 'KAFKA',
  FILE_UPLOAD = 'FILE_UPLOAD',
  PROJECT_READY = 'PROJECT_READY'
}
